<div class="hvac-scroll-to-top" [ngClass]="{'hvac-show-scrollTop': windowScrolled}">
    <button type="button" class="btn-scroll-to-top" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
        <strong class="hvac-arrow-up hvac-h4" >^</strong>
        <strong class="hvac-h5">{{ 'SCROLL_TO_TOP' | translate }}</strong>
    </button>
</div>
